import { IAppConfiguration } from '../cemexng2components/components/app-configuration';

export default [
  {
    feature: 'disputes.table-template',
    country: [
      'MX',
      'CO',
      'GB',
      'DE',
      'PA',
      'CR',
      'NI',
      'SV',
      'GT',
      'DO',
      'PR',
      'PE',
      'IL',
      'PH',
      'PL',
      'CZ',
      'FR',
      'EG'
    ],
    options: {
      columns: {
        active: [
          'disputeStatusDesc',
          'disputeDate',
          'disputeCode',
          'disputeCategoryDesc',
          'customerDesc',
          'salesOfficeCode',
          'salesOrgCode',
          'lastComment',
          'disputeBalance'
        ],
        inactive: [
          'jobSiteDesc',
          'responsibleUserName',
          'managerName',
          'disputeAmount',
          'plantDesc',
          'director',
          'salesRepName',
          'channelCode',
          'sectorCode',
          'zoneDesc',
          'regionDesc',
          'marketDesc',
          'segmentDesc'
        ],
        hidden: []
      }
    }
  },
  {
    feature: 'disputes.table-template-es',
    country: ['ES'],
    options: {
      columns: {
        active: [
          'disputeStatusDesc',
          'disputeDate',
          'disputeCode',
          'disputeCategoryDesc',
          'customerDesc',
          'salesOfficeCode',
          'jobSiteDesc',
          'plantDesc',
          'disputeAmount'
        ],
        inactive: [
          'disputeBalance',
          'lastComment',
          'salesOrgCode',
          'responsibleUserName',
          'managerName',
          'director',
          'salesRepName',
          'channelCode',
          'sectorCode',
          'zoneDesc',
          'regionDesc',
          'marketDesc',
          'segmentDesc'
        ],
        hidden: []
      }
    }
  },
  {
    feature: 'disputes.table-template-lv',
    country: ['LV'],
    options: {
      columns: {
        active: [
          'disputeStatusDesc',
          'disputeDate',
          'disputeCode',
          'disputeCategoryDesc',
          'customerDesc',
          'salesOfficeCode',
          'jobSiteDesc',
          'plantDesc',
          'disputeAmount'
        ],
        inactive: [
          'disputeBalance',
          'lastComment',
          'salesOrgCode',
          'responsibleUserName',
          'managerName',
          'director',
          'salesRepName',
          'channelCode',
          'sectorCode',
          'zoneDesc',
          'regionDesc',
          'marketDesc',
          'segmentDesc'
        ],
        hidden: []
      }
    }
  },
  {
    feature: 'disputes.table-template-cz',
    country: ['CZ'],
    options: {
      columns: {
        active: [
          'disputeStatusDesc',
          'disputeDate',
          'disputeCode',
          'customerDesc',
          'jobSiteDesc',
          'plantDesc',
          'responsibleUserName'
        ],
        inactive: [
          'managerName',
          'disputeAmount',
          'director',
          'salesRepName',
          'channelCode',
          'sectorCode',
          'zoneDesc',
          'regionDesc',
          'marketDesc',
          'segmentDesc',
          'disputeCategoryDesc',
          'salesOfficeCode',
          'salesOrgCode',
          'lastComment',
          'disputeBalance'
        ],
        hidden: []
      }
    }
  }
] as IAppConfiguration[];
